<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow
    title="Ввод"
    :is-big="isBig"
    :is-center="true"
    @close="handleClose"
  >
    <div :class="b('intro')">
      <p :class="b('subtitle')">
        {{ $t("Зачисление на счёт по вашим реквизитам") }}
      </p>

      <div :class="b('tabs')" role="tablist">
        <button
          type="button"
          :class="b('tab', { active: tab === currencyTypes.fiat })"
          role="tab"
          :aria-selected="tab === currencyTypes.fiat"
          @click="handleTab(currencyTypes.fiat)"
        >
          Fiat
        </button>
        <button
          type="button"
          :class="b('tab', { active: tab === currencyTypes.crypto })"
          role="tab"
          :aria-selected="tab === currencyTypes.crypto"
          @click="handleTab(currencyTypes.crypto)"
        >
          Crypto
        </button>
      </div>
    </div>

    <div :class="b('wrapper')">
      <div :class="b('header')">
        <WalletRequisites v-model:requisite="requisite" />
      </div>

      <component :is="displayedComponent" @update="update" />
    </div>
  </SharedWindow>
</template>
